import { render } from "./TheAdminVideoUpdate.vue?vue&type=template&id=588e37f4&ts=true"
import script from "./TheAdminVideoUpdate.vue?vue&type=script&lang=ts"
export * from "./TheAdminVideoUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__